export interface ColorScheme {
  'token-text-main-primary': string;
  'token-text-main-secondary': string;
  'token-text-main-tertiary': string;
  'token-text-main-disabled': string;
  'token-text-main-tertiary-inverse': string;
  'token-text-main-primary-inverse': string;

  'token-text-brand-primary-hover': string;
  'token-text-brand-primary': string;
  'token-text-brand-secondary': string;
  'token-text-brand-primary-inverse': string;

  'token-text-badge-green': string;
  'token-text-badge-amber': string;
  'token-text-badge-blue': string;

  'token-text-negative-red': string;

  'token-surface-primary-bw-09': string;
  'token-surface-primary-bw-08': string;
  'token-surface-primary-bw-07': string;
  'token-surface-primary-bw-06': string;
  'token-surface-primary-bw-05': string;
  'token-surface-primary-bw-04': string;
  'token-surface-primary-bw-03': string;
  'token-surface-primary-bw-02': string;
  'token-surface-primary-bw-01': string;
  'token-surface-primary-bw-00': string;

  'token-surface-brand-action-05': string;
  'token-surface-brand-action-04': string;
  'token-surface-brand-action-03': string;
  'token-surface-brand-action-02': string;
  'token-surface-brand-action-01': string;
  'token-surface-brand-action-00': string;

  'token-surface-negative-primary': string;
  'token-surface-negative-secondary': string;
  'token-surface-negative-tertiary': string;

  'token-surface-badge-orange': string;
  'token-surface-badge-red': string;
  'token-surface-badge-green': string;
  'token-surface-badge-amber': string;
  'token-surface-badge-blue-02': string;
  'token-surface-badge-blue-00': string;

  'token-surface-purple-primary': string;
  'token-surface-purple-secondary': string;

  'token-surface-yellow-primary': string;

  'token-surface-orange-primary': string;
  'token-surface-orange-secondary': string;
  'token-surface-orange-tertiary': string;

  'token-surface-green-primary': string;

  'token-outline-primary-bw-09': string;
  'token-outline-primary-bw-08': string;
  'token-outline-primary-bw-07': string;
  'token-outline-primary-bw-06': string;
  'token-outline-primary-bw-05': string;
  'token-outline-primary-bw-04': string;
  'token-outline-primary-bw-03': string;
  'token-outline-primary-bw-02': string;
  'token-outline-primary-bw-01': string;
  'token-outline-primary-bw-00': string;

  'token-outline-brand-primary': string;
  'token-outline-brand-secondary': string;
  'token-outline-brand-tertiary': string;
  'token-outline-brand-primary-inverse': string;

  'token-outline-amber-primary': string;

  'token-outline-purple-primary': string;
  'token-outline-purple-secondary': string;

  'token-outline-positive-primary': string;
  'token-outline-positive-secondary': string;

  'token-outline-negative-primary': string;

  'token-outline-orange-primary': string;

  'token-transparent': string;
}

export const liliColorScheme: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#0042C4',
  'token-text-brand-primary': '#0E5CF4',
  'token-text-brand-secondary': '#75BDFF',
  'token-text-brand-primary-inverse': '#F2F8FF',

  'token-text-badge-green': '#00B16A',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#008FDB',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-action-05': '#00193C',
  'token-surface-brand-action-04': '#0042C4',
  'token-surface-brand-action-03': '#0E5CF4',
  'token-surface-brand-action-02': '#75BDFF',
  'token-surface-brand-action-01': '#C5E3FF',
  'token-surface-brand-action-00': '#F2F8FF',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#008FDB',
  'token-surface-badge-blue-00': '#E7F4FE',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#0E5CF4',
  'token-outline-brand-secondary': '#75BDFF',
  'token-outline-brand-tertiary': '#C5E3FF',
  'token-outline-brand-primary-inverse': '#F2F8FF',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00B16A',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const dunAndBradstreetColorScheme: ColorScheme = {
  'token-text-main-primary': '#161919',
  'token-text-main-secondary': '#868686',
  'token-text-main-tertiary': '#868686',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#3095B4',
  'token-text-brand-primary': '#0078A7',
  'token-text-brand-secondary': '#3095B4',
  'token-text-brand-primary-inverse': '#F1F6F8',

  'token-text-badge-green': '#00B16A',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#008FDB',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-02': '#F7F7F7',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-action-05': '#101820',
  'token-surface-brand-action-04': '#3095B4',
  'token-surface-brand-action-03': '#0078A7',
  'token-surface-brand-action-02': '#3095B4',
  'token-surface-brand-action-01': '#3095B43D',
  'token-surface-brand-action-00': '#F1F6F8',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#008FDB',
  'token-surface-badge-blue-00': '#E7F4FE',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#0078A7',
  'token-outline-brand-secondary': '#3095B4',
  'token-outline-brand-tertiary': '#3095B43D',
  'token-outline-brand-primary-inverse': '#F1F6F8',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00B16A',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const applyColorScheme = (colorScheme: ColorScheme) => {
  // Access the root of the document (the :root CSS selector)
  const root = document.documentElement;

  // Iterate over the keys in the color scheme object
  Object.keys(colorScheme).forEach((token) => {
    // Set each CSS variable (custom property) in the :root element
    root.style.setProperty(`--${token}`, colorScheme[token as keyof ColorScheme]);
  });
};
